import { cn } from "@quortex/front-common"
import type { FC } from "react"

interface DashboardCardProps {
  children: React.ReactNode
  className?: string
}

const DashboardCard: FC<DashboardCardProps> = ({ children, className }) => (
  <div className={cn("radius border border-grey-300 bg-white p-md", className)}>{children}</div>
)

export default DashboardCard
